import baseAPI from '@/http'

const router = 'api/municipio-secretaria'

export const citySecretariaAPI = {
    create: (cityEvidence) => baseAPI.post(router, cityEvidence),
    update: (cityEvidence) => baseAPI.put(router, cityEvidence),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    find: (id) => baseAPI.get(`${router}/${id}`),
    list: () => baseAPI.get(`${router}`),
    findByMunicipio: (municipioId) => baseAPI.get(`${router}/get-secretaria-by-municipioId/${municipioId}`),
    cadastrarMultiplos: (cityEvidence) => baseAPI.post(`${router}/cadastrar-municipio-secretaria`, cityEvidence),
}
